const PREFIX = "PROFITISHOP_GQL_";

export const QUERY_TTL = {
  categories: 15 * 60 * 1000,
  allCategories: 15 * 60 * 1000,
  brands: 30 * 60 * 1000,
  attributesOrder: 30 * 60 * 1000,
  footer: 60 * 60 * 1000,
  attributeFilters: 5 * 60 * 1000,
  viewer: 10 * 60 * 1000,
};

interface PersistedQueryEntry<T> {
  data: T;
  fetchedAt: number;
}

export const readPersistedQuery = <T>(key: string): T | undefined => {
  try {
    const raw = localStorage.getItem(`${PREFIX}${key}`);
    if (!raw) {
      return undefined;
    }

    const parsed = JSON.parse(raw) as PersistedQueryEntry<T>;
    return parsed?.data;
  } catch (e) {
    return undefined;
  }
};

export const isPersistedQueryFresh = (key: string, ttlMs: number): boolean => {
  try {
    const raw = localStorage.getItem(`${PREFIX}${key}`);
    if (!raw) {
      return false;
    }

    const parsed = JSON.parse(raw) as PersistedQueryEntry<unknown>;
    if (!parsed?.fetchedAt) {
      return false;
    }

    return Date.now() - parsed.fetchedAt < ttlMs;
  } catch (e) {
    return false;
  }
};

export const writePersistedQuery = <T>(key: string, data: T) => {
  try {
    const entry: PersistedQueryEntry<T> = {
      data,
      fetchedAt: Date.now(),
    };
    localStorage.setItem(`${PREFIX}${key}`, JSON.stringify(entry));
  } catch (e) {
    // Quota or private mode: ignore, network path still works.
  }
};

export const persistKeyFromVariables = (name: string, variables?: unknown) => {
  if (!variables) {
    return name;
  }

  try {
    return `${name}:${JSON.stringify(variables)}`;
  } catch (e) {
    return name;
  }
};
